angular.module('app')
    .controller('adminGdprController', adminGdprController);

adminGdprController.$inject = [
    'SettingsApi',
    'alerts',
    'settingsConfig',
    'siteSettings',
];

function adminGdprController(
    SettingsApi,
    alerts,
    settingsConfig,
    siteSettings
) {
    var vm = this;

    // properties
    vm.loadingConfig = {
        show: false,
        message: 'Saving...',
    };
    vm.settings = angular.copy(siteSettings);

    // methods
    vm.handleEmailReminderContentChange = handleEmailReminderContentChange;
    vm.handleSignupNoticeContentChange = handleSignupNoticeContentChange;
    vm.saveSettings = saveSettings;

    /**
     * Updates scope when the email message content is changed.
     *
     * @param {string} content
     * @returns {void}
     */
    function handleEmailReminderContentChange(content) {
        vm.settings.gdpr_settings.reminder.content = content;
    }

    /**
     * Updates scope when the signup notice content is changed.
     *
     * @param {string} content
     * @returns {void}
     */
    function handleSignupNoticeContentChange(content) {
        vm.settings.gdpr_settings.signup.content = content;
    }

    /**
     * Saves settings to the API
     *
     * @returns {void}
     */
    function saveSettings() {
        vm.loadingConfig.show = true;
        const data: Record<string, any> = {};

        // get only those settings that have changed.
        settingsConfig.forEach(key => {
            data[key] = vm.settings[key];
        });

        // if no data set.
        if (angular.equals({}, data)) {
            handleSuccess();
            return;
        }

        const origContent = siteSettings.gdpr_settings && siteSettings.gdpr_settings.signup && siteSettings.gdpr_settings.signup.content;
        const newContent = data.gdpr_settings && data.gdpr_settings.signup && data.gdpr_settings.signup.content;
        if (origContent !== newContent) {
            data.gdpr_settings.signup.modified = window.moment().format('YYYY-MM-DD HH:mm:ss');
        }

        SettingsApi.save({ settings: data }, handleSuccess, resp => {
            vm.loadingConfig.show = false;
            vm.formErrors = resp.data;
        }).suppressValidationAlerts();

        function handleSuccess() {
            vm.loadingConfig.show = false;
            alerts.emit({
                theme: 'success',
                title: 'Saved',
                messages: ['GDPR Settings']
            });
        }
    }
}